import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { BackgroundColorOpacityTitle, Href } from "../../../Constants/Constants";
import { BackgroundColorOpacityData, BackgroundColorOpacitySubTitle } from "../../../Data/UiKits/NavigateLinks";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BackgroundColorOpacity = () => {
  return (
    <Col xxl="3" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={BackgroundColorOpacityTitle} span={BackgroundColorOpacitySubTitle} />
        <CardBody className="bg-opacity-wrapper">
          {BackgroundColorOpacityData.map((item, index) => (
            <div className={`mb-3 p-2 ${item.class}`} key={index}>
              <Link to={Href}>This is {item.text} primary border</Link>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default BackgroundColorOpacity;
